export default {
    notSet: 0,
    widget: 1,
    facebook: 2,
    phoneCall: 3,
    sms: 4
}
